import React, { Fragment, useEffect, useMemo, useRef, useState } from "react";
import {} from "../../core/feature/store";
import { useAppSelector, useAppDispatch } from "../../core/feature/hooks";
import { setLoading } from "../../core/feature/config/configSlice";

import { useNavigate } from "react-router-dom";
import User from "../../core/models/user";
import { toast } from "react-toastify";
import "react-multi-carousel/lib/styles.css";
import userweb from "../../assets/images/icon_home/user.svg";
import { getUser } from "../../core/service/api_card";
import { StatsProfil } from "../common/home/Stats";
import { updatePassword, uploadPhoto } from "../../core/service/api_profile";
import users from "../../../src/assets/images/icon_profile/user.svg";
import login from "../../../src/assets/images/icon_profile/lock.svg";
import pin from "../../../src/assets/images/icon_profile/key.svg";
import faq from "../../../src/assets/images/icon_profile/book.svg";
import bahasa from "../../../src/assets/images/icon_profile/globe.svg";
import logoutIcon from "../../../src/assets/images/icon_profile/log-out.svg";
import { removeUser, setUser } from "../../core/feature/user/userSlice";
import { removeBalance } from "../../core/feature/user/balanceSlice";
import { Dialog, Transition } from "@headlessui/react";
import { useTranslation } from "react-i18next";
import Config from "../../config/Config";
import { updateUser } from "../../core/service/api_profile";
import { i18n } from "../../translations/i18n";
import { setLanguage } from "../../core/feature/language/languageSlice";
import camera from "../../assets/images/icon_profile/Camera.svg";
import eye from "../../assets/images/icon_login/eye.svg";
import eyeclose from "../../assets/images/icon_login/eyeclose.svg";
import { removeIconApp } from "../../core/feature/company/iconAppSlice";
import { removeCustomApp } from "../../core/feature/company/customAppsSlice";
import { removeToken } from "../../core/feature/token/tokenSlice";
import { removeLastService } from "../../core/feature/lastService/lastServiceSlice";
import useAnalyticsEventTracker from "../../core/service/useAnalyticsEventTracker";
import CustomApp from "../../core/models/customApp";
import { isDarkColor } from "../../config/DarkColorChecker";
import { SwitchAccount } from "../__template/SwitchAccount";
import SwitchAccountIcon from "../../assets/images/switch.svg";

const ProfileWeb = () => {
  const gaEventTracker = useAnalyticsEventTracker("LogOut");
  const gaEventChangeTracker = useAnalyticsEventTracker("EditData");
  const customApp: CustomApp = useAppSelector(
    (state) => state.customApp.customApp
  );
  const [typeOldPassword, setTypeOldPassword] = useState("password");
  const [typeNewPassword, setTypeNewPassword] = useState("password");
  const [typeNewPassword2, setTypeNewPassword2] = useState("password");
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const user: User = useAppSelector((state) => state.user.user);
  const language: String = useAppSelector((state) => state.language.language);
  let [openSwitchAccount, setOpenSwitchAccount] = useState(false);
  const [lang, setLang] = useState(i18n.language);
  const [menuProfile, setMenuProfile] = useState(false);
  const [menuLoginOtomatis, setMenuLoginOtomatis] = useState(false);
  const [menuUbahPassword, setMenuUbahPassword] = useState(false);
  const [menuFaq, setmenuFaq] = useState(false);
  const [menuBahasa, setmenuBahasa] = useState(false);
  const [previewImage, setPreviewImage] = useState<any>();
  const [image, setImage] = useState<any>();
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [auto, setAutoLogin] = useState(
    localStorage.getItem("auto_login") === "1" ? true : false
  );
  const [appName, setAppName] = useState("");

  useEffect(() => {
    const app = localStorage.getItem("app_version")?.replace("--", " ");
    if (app) {
      setAppName(app);
    }
  }, []);

  const logout = async () => {
    dispatch(removeUser());
    dispatch(removeIconApp());
    dispatch(removeBalance());
    dispatch(removeCustomApp());
    dispatch(removeUser());
    dispatch(removeBalance());
    dispatch(removeToken());
    dispatch(removeLastService());
    navigate("/login", { replace: true });
    gaEventTracker("Click Log Out", "User Logout");
    console.log(user);
    // var element = document.createElement("a") as HTMLElement;
    // element.setAttribute("href", "pspmobile://logout");
    // try {
    //   element.click();
    // } catch (error) { }
  };

  const cancelEdit = () => {
    setMenuProfile(false);
    getUser().then((res) => {
      console.log(res.data);
      setData(res.data);
      setEmail(res.data.email);
      setPhone(res.data.phone);
      dispatch(setUser(res.data));
    });
    setInputActive(true);
  };

  const cancel = () => {
    setMenuUbahPassword(false);
    setOldPassword("");
    setNewPassword("");
    setNewPassword2("");
  };

  const bukaProfile = () => {
    setMenuProfile(!menuProfile);
    setMenuLoginOtomatis(false);
    setOldPassword("");
    setNewPassword("");
    setNewPassword2("");
    setMenuUbahPassword(false);
    setmenuFaq(false);
    setmenuBahasa(false);
  };

  const bukaLogin = () => {
    setMenuProfile(false);
    setMenuLoginOtomatis(!menuLoginOtomatis);
    setMenuUbahPassword(false);
    setmenuFaq(false);
    setmenuBahasa(false);
  };

  const bukaPassword = () => {
    setMenuProfile(false);
    setMenuLoginOtomatis(false);
    setMenuUbahPassword(!menuUbahPassword);
    setOldPassword("");
    setNewPassword("");
    setNewPassword2("");
    setmenuFaq(false);
    setmenuBahasa(false);
  };

  const bukaBahasa = () => {
    setMenuProfile(false);
    setMenuLoginOtomatis(false);
    setMenuUbahPassword(false);
    setOldPassword("");
    setNewPassword("");
    setNewPassword2("");
    setmenuFaq(false);
    setmenuBahasa(!menuBahasa);
  };

  const logoutAction = async () => {
    setIsOpen(true);
  };
  const closeActionLogout = async () => {
    setIsOpen(false);
  };
  let [isOpen, setIsOpen] = useState(false);

  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [inputActive, setInputActive] = useState(true);
  const [update, setUpdate] = useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newPassword2, setNewPassword2] = useState("");
  const emailRef = useRef<HTMLInputElement>(null);
  const phoneRef = useRef<HTMLInputElement>(null);
  const [data, setData] = useState<any>({});
  const [imgData, setImgData] = useState<any>(null);
  const { t } = useTranslation();
  const env = Config.BaseUrlDev;

  const getProfileImage = useMemo(() => {
    if (user?.photoUrl == "") {
      return users;
    }
    return env + "main_a/image/get/" + user?.photoUrl + "/pas";
  }, [user]);

  const updateData = async () => {
    dispatch(setLoading(true));
    const regexEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    if (email == "")
      return (
        toast.warning(t("LOGIN.warningEmail")), dispatch(setLoading(false))
      );
    if (phone == "")
      return toast.warning(t("LOGIN.warningWA")), dispatch(setLoading(false));
    if (email && !email.match(regexEmail))
      return (
        toast.warning(t("LOGIN.warningEmail")), dispatch(setLoading(false))
      );
    // if (phone && phone.length < 10) return dispatch(setLoading(false));
    // toast.warning(t("LOGIN.warningWA"));

    setData({
      ...data,
      email: emailRef.current?.value,
      phone: phoneRef.current?.value,
    });
    // setData({ ...data, phone: phoneRef.current?.value });
    setMenuProfile(false);
    setUpdate(true);
  };

  function getUserData() {
    getUser().then((res) => {
      console.log(res.data);
      setData(res.data);
      setEmail(res.data.email);
      setPhone(res.data.phone);
      dispatch(setUser(res.data));
    });
  }

  const onChangePicture = (event: any) => {
    if (event.target.files && event.target.files[0]) {
      setImgData(URL.createObjectURL(event.target.files[0]));
      console.log(URL.createObjectURL(event.target.files[0]));
    }
  };

  const funTypePassword = async (type: string) => {
    switch (type) {
      case "old":
        if (typeOldPassword == "text") {
          setTypeOldPassword("password");
        } else {
          setTypeOldPassword("text");
        }
        break;
      case "new":
        if (typeNewPassword == "text") {
          setTypeNewPassword("password");
        } else {
          setTypeNewPassword("text");
        }
        break;
      default:
        if (typeNewPassword2 == "text") {
          setTypeNewPassword2("password");
        } else {
          setTypeNewPassword2("text");
        }
        break;
    }
  };

  const updatePass = async () => {
    if (oldPassword == "") return toast.warning(t("PROFILE.old"));
    else if (newPassword == "") return toast.warning(t("PROFILE.new1"));
    else if (newPassword2 == "") return toast.warning(t("PROFILE.new2"));

    const number = /[0-9]/g;

    if (newPassword.length && newPassword2.length < 6)
      return toast.warning(t("PROFILE.length"));
    else if (!number.test(newPassword && newPassword2))
      return toast.warning(t("PROFILE.number"));

    if (newPassword !== newPassword2) return toast.warning(t("PROFILE.same"));
    dispatch(setLoading(true));
    var query = {
      oldPassword: oldPassword,
      newPassword: newPassword,
    };

    updatePassword(query)
      .then((res) => {
        console.log(res);
        dispatch(setLoading(false));
        toast.success(t("PROFILE.changeSuccess"));
        gaEventChangeTracker("Click Change Password", "Change Password");
        setOldPassword("");
        setNewPassword("");
        setNewPassword2("");
        var auto = "1";
        var CryptoJS = require("crypto-js");
        var getCredential = localStorage.getItem("credential");
        var bytes = CryptoJS.AES.decrypt(getCredential, "credential");
        var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        var data = decryptedData;
        data.password = newPassword;
        var ciphertext = CryptoJS.AES.encrypt(
          JSON.stringify(data),
          "credential"
        ).toString();
        localStorage.setItem("credential", ciphertext);
        logout();
      })
      .catch((err) => {
        dispatch(setLoading(false));
      });
  };

  useEffect(() => {
    if (lang !== language) {
      i18n.changeLanguage(lang);
      dispatch(setLanguage(lang));
      toast(t("OTHER.success"));
    }
  }, [lang]);

  const handleClick = () => {
    inputRef?.current?.click();
  };
  const inputHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.currentTarget.files) {
      // you can display the error to the user
      console.error("Select a file");
      const enteredName = event?.currentTarget?.files[0];
      // setIsImage(enteredName.type.includes("image/"));
      setImage(enteredName);
      setPreviewImage(URL.createObjectURL(enteredName));
      // onClickUpdateImage();
      return;
    }
  };

  useEffect(() => {
    if (image != undefined) {
      dispatch(setLoading(true));
      uploadPhoto(image)
        .then((res) => {
          dispatch(setLoading(false));
          setData({
            ...data,
            photoUrl: res.data.name,
          });
          setUpdate(true);
        })
        .catch((err) => {
          console.log(err);
          dispatch(setLoading(false));
          navigate("/profile", { replace: true });
        });
    } else {
      dispatch(setLoading(false));
      navigate("/profile", { replace: true });
    }
  }, [image]);

  // useEffect(() => {
  //   if (update == true) {
  //     dispatch(setLoading(true));
  //     updateUser(data)
  //       .then((res: any) => {
  //         dispatch(setLoading(false));
  //         setInputActive(true);
  //         getUserData();
  //         setUpdate(false);
  //         toast.success("Update Profile Berhasil");
  //       })
  //       .catch((err) => {
  //         dispatch(setLoading(false));
  //         navigate("/login", { replace: true });
  //       });
  //   }
  // }, [update, data]);

  useEffect(() => {
    if (update == true) {
      dispatch(setLoading(true));
      updateUser(data)
        .then((res: any) => {
          dispatch(setLoading(false));
          setInputActive(true);
          getUserData();
          setUpdate(false);
          toast.success(t("PROFILE.success"));
        })
        .catch((err) => {
          console.log(err);
          dispatch(setLoading(false));
          navigate("/profile", { replace: true });
        });
    } else {
      dispatch(setLoading(false));
      navigate("/profile", { replace: true });
    }
  }, [update, data]);

  useEffect(() => {
    getUserData();
  }, []);

  return (
    <>
      <div className="bg-psp-primary mb-8 font-montserrat">
        {/* <Carousal /> */}
        <StatsProfil />
        <div className="h-auto  flex relative bg-psp-primary">
          <div className="container -mt-10 h-full flex-row relative flex justify-between mb-16">
            <div className="flex flex-col z-0 rounded-2xl bg-white items-center py-2 relative shadow-lg px-8 w-6/12 my-2 ">
              <div className="flex items-center py-2 px-2 w-full mb-8">
                <img
                  onContextMenuCapture={(e) => {
                    console.log(e);
                  }}
                  src={getProfileImage}
                  alt=""
                  className="w-20 h-20 object-cover shadow rounded-full"
                />
                <div className="flex grow flex-col ml-8 mt-3">
                  <span className="text-3xl">{user?.name}</span>
                  <span style={{ color: "gray" }}>{user?.email}</span>
                </div>

                <span
                  onClick={(e) => {
                    setOpenSwitchAccount(!openSwitchAccount);
                    e.stopPropagation();
                  }}
                  className="p-2 rounded-md hover:bg-slate-700/10 w-fit h-fit"
                >
                  <img src={SwitchAccountIcon} alt="switch_account" />
                </span>
                <SwitchAccount
                  setOpen={setOpenSwitchAccount}
                  open={openSwitchAccount}
                />
              </div>
              <button
                onClick={() => bukaProfile()}
                className="flex px-2 py-2 w-full hover:bg-[#D7EDFF] hover:rounded-lg focus:bg-[#D7EDFF] focus:text-psp-primary focus:font-bold focus:rounded-lg"
                style={{ borderColor: "#B2B4C3" }}
              >
                <img src={users} alt="" className="w-8" />
                <div className="flex flex-col justify-center ml-10 w-2/3 ">
                  <h1 className="text-xl font-light mt-1 text-left">
                    {t("PROFILE.title")}
                  </h1>
                </div>
              </button>
              {/* <button
                onClick={() => bukaLogin()}
                className="flex px-2 py-2 w-full hover:bg-[#D7EDFF] hover:rounded-lg focus:bg-[#D7EDFF] focus:text-psp-primary focus:font-bold focus:rounded-lg"
                style={{ borderColor: "#B2B4C3" }}
              >
                <img src={login} alt="" className="w-8" />
                <div className="flex flex-col justify-center ml-10 w-2/3 ">
                  <h1 className="text-xl font-light mt-1 text-left">
                    {t("PROFILE.autoLogin")}
                  </h1>
                </div>
              </button> */}
              <button
                onClick={() => bukaPassword()}
                className="flex px-2 py-2 w-full hover:bg-[#D7EDFF] hover:rounded-lg focus:bg-[#D7EDFF] focus:text-psp-primary focus:font-bold focus:rounded-lg"
                style={{ borderColor: "#B2B4C3" }}
              >
                <img src={pin} alt="" className="w-8" />
                <div className="flex flex-col justify-center ml-10 w-2/3 ">
                  <h1 className="text-xl font-light mt-1 text-left">
                    {t("PROFILE.changePassword")}
                  </h1>
                </div>
              </button>
              <button
                onClick={() => navigate("/faq")}
                className="flex px-2 py-2 w-full hover:bg-[#D7EDFF] hover:rounded-lg focus:bg-[#D7EDFF] focus:text-psp-primary focus:font-bold focus:rounded-lg"
                style={{ borderColor: "#B2B4C3" }}
              >
                <img src={faq} alt="" className="w-8" />
                <div className="flex flex-col justify-center ml-10 w-2/3 ">
                  <h1 className="text-xl font-light mt-1 text-left">
                    {t("PROFILE.faq")}
                  </h1>
                </div>
              </button>
              <button
                onClick={() => bukaBahasa()}
                className="flex px-2 py-2 w-full hover:bg-[#D7EDFF] hover:rounded-lg focus:bg-[#D7EDFF] focus:text-psp-primary focus:font-bold focus:rounded-lg"
                style={{ borderColor: "#B2B4C3" }}
              >
                <img src={bahasa} alt="" className="w-8" />
                <div className="flex flex-col justify-center ml-10 w-2/3 ">
                  <h1 className="text-xl font-light mt-1 text-left">
                    {t("PROFILE.language")}
                  </h1>
                </div>
              </button>
              <button
                onClick={() => logoutAction()}
                className="flex px-2 py-2 w-full hover:bg-[#D7EDFF] hover:rounded-lg focus:bg-[#D7EDFF] focus:text-psp-primary focus:font-bold focus:rounded-lg"
                style={{ borderColor: "#B2B4C3" }}
              >
                <img src={logoutIcon} alt="" className="w-8" />
                <button
                  onClick={() => logoutAction()}
                  className="flex flex-col justify-center ml-10 w-2/3"
                >
                  <h1 className="text-xl font-light mt-1 text-left">
                    {t("PROFILE.logout")}
                  </h1>
                </button>
              </button>
              {appName && (
                <div className="text-gray-400 py-3 text-center">{appName}</div>
              )}
              {/* <div
              className="flex rounded-xl border px-2 w-full mb-8"
              style={{ borderColor: "#B2B4C3" }}
            >
              <img src={userweb} alt="" className="" />
              <div className="flex flex-col ml-8">
                <h1 className="text-xl">Jhon doe</h1>
                <p style={{ color: "gray" }}>sfsdfdskfk</p>
              </div>
            </div> */}
            </div>

            <div
              style={{
                zIndex: 1,
                opacity: !menuProfile ? "0" : "1",
                transition: "0.7s",
                visibility: !menuProfile ? "hidden" : "visible",
              }}
              className="rounded-2xl bg-white items-center relative py-2 h-auto px-2 w-6/12 my-2 ml-4  shadow-lg pb-5"
            >
              <div className="flex flex-col py-2 px-2 w-full">
                <div className="flex w-full flex-col ml-8">
                  <h1 className="my-2 text-2xl">{t("PROFILE.title")}</h1>
                </div>
                <div className="w-full relative flex flex-col  pl-8 pr-8">
                  <div
                    onClick={() => handleClick()}
                    className="w-full object-center relative flex flex-row justify-center hover:cursor-pointer"
                  >
                    <img
                      src={previewImage || getProfileImage}
                      alt=""
                      className="w-36 h-36 object-cover relative rounded-full z-[1] opacity-80"
                    />
                    <input
                      accept="image/*"
                      style={{ display: "none" }}
                      ref={inputRef}
                      type="file"
                      className="bg-red opacity-0 w-36 h-36 rounded-full cursor-pointer absolute"
                      onChange={inputHandler}
                    />
                    <img
                      src={camera}
                      alt=""
                      className="absolute z-[2] w-10 translate-y-[150%]"
                    />
                    {/* <div>

                    </div> */}
                  </div>
                  <form className="pt-3">
                    <label className="text-lg">Email</label>
                    <br />
                    <input
                      type="text"
                      placeholder={user?.email}
                      value={email}
                      disabled={inputActive}
                      ref={emailRef}
                      onChange={(e) => setEmail(e.target.value)}
                      className="py-3 px-3 w-full border rounded-lg disabled:text-gray-500"
                    ></input>
                  </form>
                  <form className="pt-3">
                    <label className="text-lg">Telepon</label>
                    <br />
                    <input
                      type="number"
                      placeholder={user?.phone}
                      disabled={inputActive}
                      value={phone}
                      ref={phoneRef}
                      onChange={(e) => setPhone(e.target.value)}
                      className="py-3 px-3 w-full border rounded-lg disabled:text-gray-500"
                    ></input>
                  </form>
                  <button
                    hidden={!inputActive}
                    onClick={() => setInputActive(false)}
                    className={`w-full py-3 mt-4 rounded-xl hover:opacity-75 ${
                      isDarkColor(customApp.app_secondary_accent_color)
                        ? "text-white"
                        : "text-black"
                    }`}
                    style={{
                      backgroundColor: customApp?.app_secondary_accent_color,
                    }}
                  >
                    {t("OTHER.edit")}
                  </button>
                  <button
                    hidden={inputActive}
                    onClick={() => updateData()}
                    style={{ backgroundColor: customApp?.app_accent_color }}
                    className={`w-full py-3 mt-4 rounded-xl hover:opacity-75 ${
                      isDarkColor(customApp.app_accent_color)
                        ? "text-white"
                        : "text-black"
                    }`}
                  >
                    {t("DIGITALCARD.save")}
                  </button>
                  <button
                    onClick={() => cancelEdit()}
                    style={{
                      backgroundColor: customApp?.app_secondary_accent_color,
                    }}
                    className={`w-full py-3 mt-3 rounded-xl hover:bg-rose-700 ${
                      isDarkColor(customApp.app_secondary_accent_color)
                        ? "text-white"
                        : "text-black"
                    }`}
                  >
                    {t("DIGITALCARD.cancel")}
                  </button>
                </div>
              </div>
            </div>

            {/* <div
              style={{
                position: "absolute",
                zIndex: 2,
                opacity: !menuLoginOtomatis ? "0" : "1",
                transition: "0.7s",
                visibility: !menuLoginOtomatis ? "hidden" : "visible",
              }}
              className="rounded-2xl bg-white items-center relative py-2 h-auto px-2 w-6/12 my-2 ml-4  shadow-lg pb-5 right-0"
            >
              <div className="flex flex-col py-2 px-2 w-full">
                <div className="flex w-full flex-col ml-8">
                  <h1 className="my-2 text-2xl">{t("PROFILE.autoLogin")}</h1>
                </div>
                <div className="w-full   pl-8 pr-8">
                  <p>Apakah anda akan menggunakan fitur login otimatis</p>
                </div>
                <div className="ml-10 text-slate-400">
                  <form>
                    <input
                      type="radio"
                      id="ya"
                      name="option"
                      checked={auto}
                      onClick={(e: any) => {
                        if (e.target.value == 'on') {
                          setAutoLogin(true)
                          localStorage.setItem('auto_login', '1')
                        } else {
                          setAutoLogin(false)
                          localStorage.setItem('auto_login', '0')
                        }
                      }}
                    ></input>
                    <label form="radio" className="ml-3">
                      {t("OTHER.yes")}
                    </label>
                    <br />
                    <input
                      type="radio"
                      id="tidak"
                      name="option"
                      checked={!auto}
                      onClick={(e: any) => {
                        if (e.target.value == 'on') {
                          setAutoLogin(false)
                          localStorage.setItem('auto_login', '0')
                        } else {
                          setAutoLogin(true)
                          localStorage.setItem('auto_login', '1')
                        }
                      }}
                    ></input>
                    <label form="radio" className="ml-3">
                      {t("OTHER.no")}
                    </label>
                  </form>
                </div>
              </div>
            </div> */}

            <div
              style={{
                position: "absolute",
                zIndex: 3,
                opacity: !menuUbahPassword ? "0" : "1",
                transition: "0.7s",
                visibility: !menuUbahPassword ? "hidden" : "visible",
              }}
              className="rounded-2xl right-0 bg-white items-center relative py-2 h-auto px-2 w-6/12 my-2 ml-4  shadow-lg pb-5"
            >
              <div className="flex flex-col py-2 px-2 w-full">
                <div className="flex w-full flex-col ml-8">
                  <h1 className="my-2 text-2xl">
                    {t("PROFILE.changePassword")}
                  </h1>
                </div>
                <div className="w-full pl-8 pr-8">
                  <form className="pt-2">
                    <label className="text-lg">
                      {t("PROFILE.oldPassword")}
                    </label>
                    <br />
                    <div className="relative flex w-full">
                      <input
                        className="py-3 px-3 w-full border rounded-lg"
                        type={typeOldPassword}
                        onChange={(e) => setOldPassword(e.target.value)}
                        value={oldPassword}
                      />
                      <img
                        src={typeOldPassword == "text" ? eye : eyeclose}
                        className="font-bold text-black absolute z-10 top-4 right-3 hover:cursor-pointer"
                        onClick={() => funTypePassword("old")}
                      />
                    </div>
                  </form>
                  <form className="pt-2">
                    <label className="text-lg">
                      {t("PROFILE.newPassword")}
                    </label>
                    <br />
                    <div className="flex relative w-full">
                      <input
                        className="py-3 px-3 w-full border rounded-lg"
                        type={typeNewPassword}
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                      />
                      <img
                        src={typeNewPassword == "text" ? eye : eyeclose}
                        className="font-bold text-black absolute z-10 top-4 right-3 hover:cursor-pointer"
                        onClick={() => funTypePassword("new")}
                      />
                    </div>
                  </form>
                  <form className="pt-2">
                    <label className="text-lg">{t("PROFILE.rePassword")}</label>
                    <br />
                    <div className="flex w-full relative">
                      <input
                        className="py-3 px-3 w-full border rounded-lg"
                        value={newPassword2}
                        type={typeNewPassword2}
                        onChange={(e) => setNewPassword2(e.target.value)}
                      />
                      <img
                        src={typeNewPassword2 == "text" ? eye : eyeclose}
                        className="font-bold text-black absolute z-10 top-4 right-3 hover:cursor-pointer"
                        onClick={() => funTypePassword("new2")}
                      />
                    </div>
                  </form>
                  <button
                    onClick={() => updatePass()}
                    style={{ backgroundColor: customApp?.app_accent_color }}
                    className={`w-full py-3 mt-4 rounded-xl hover:opacity-75 ${
                      isDarkColor(customApp.app_accent_color)
                        ? "text-white"
                        : "text-black"
                    }`}
                  >
                    {t("DIGITALCARD.save")}
                  </button>
                  <button
                    onClick={() => cancel()}
                    style={{
                      backgroundColor: customApp?.app_secondary_accent_color,
                    }}
                    className={`w-full py-3 mt-3 rounded-xl bg-psp-btn-red hover:bg-rose-700 ${
                      isDarkColor(customApp.app_secondary_accent_color)
                        ? "text-white"
                        : "text-black"
                    }`}
                  >
                    {t("DIGITALCARD.cancel")}
                  </button>
                </div>
              </div>
            </div>

            <div
              style={{
                position: "absolute",
                zIndex: 4,
                opacity: !menuFaq ? "0" : "1",
                transition: "0.7s",
                visibility: !menuFaq ? "hidden" : "visible",
              }}
              className="rounded-2xl bg-white items-center relative py-2 h-auto px-2 w-6/12 my-2 ml-4  shadow-lg pb-5 right-0"
            >
              <div className="flex flex-col py-2 px-2 w-full">
                <div className="flex w-full flex-col ml-8">
                  <h1 className="my-2 text-2xl text-slate-400">FAQ</h1>
                </div>
                <div className="w-full   pl-8 pr-8">
                  <div className="w-full bject-center">
                    <img
                      src={userweb}
                      alt=""
                      className="w-[124px] mx-auto"
                    ></img>
                  </div>
                  <form className="pt-3">
                    <label className="text-lg">Email</label>
                    <br />
                    <input className="py-3 px-3 w-full border rounded-lg"></input>
                  </form>
                  <form className="pt-3">
                    <label className="text-lg">Telepon</label>
                    <br />
                    <input className="py-3 px-3 w-full border rounded-lg"></input>
                  </form>
                  <button className="w-full py-3 mt-4 rounded-xl text-white bg-psp-btn-primary hover:bg-blue-800">
                    {t("DIGITALCARD.save")}
                  </button>
                  <button className="w-full py-3 mt-3 rounded-xl text-white bg-psp-btn-red hover:bg-rose-700">
                    {t("DIGITALCARD.cancel")}
                  </button>
                </div>
              </div>
            </div>

            <div
              style={{
                position: "absolute",
                zIndex: 6,
                opacity: !menuBahasa ? "0" : "1",
                transition: "0.7s",
                visibility: !menuBahasa ? "hidden" : "visible",
              }}
              className="rounded-2xl bg-white items-center relative py-2 h-auto px-2 w-6/12 my-2 ml-4  shadow-lg pb-5 right-0"
            >
              <div className="flex flex-col py-2 px-2 w-full">
                <div className="flex w-full flex-col ml-8">
                  <h1 className="my-2 text-2xl">{t("PROFILE.language")}</h1>
                </div>
                <div className="w-full   pl-8 pr-8">
                  <p>{t("PROFILE.warningLanguage")}</p>
                </div>
                <div className="ml-10">
                  <form>
                    <input
                      type="radio"
                      id="id"
                      name="option"
                      value="id"
                      checked={lang === "id"}
                      onChange={(e) => setLang(e.target.value)}
                    ></input>
                    <label form="radio" className="ml-3">
                      Indonesia
                    </label>
                    <br />
                    <input
                      type="radio"
                      name="autoLogin"
                      value="en"
                      id="en"
                      checked={lang === "en"}
                      onChange={(e) => setLang(e.target.value)}
                    ></input>
                    <label form="radio" className="ml-3">
                      Inggris
                    </label>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Transition appear show={isOpen} as={Fragment}>
          <Dialog
            as="div"
            className="relative z-10"
            onClose={closeActionLogout}
          >
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-black bg-opacity-25" />
            </Transition.Child>

            <div className="fixed inset-0 overflow-y-auto font-montserrat">
              <div className="flex min-h-full items-center justify-center p-4 text-center">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 scale-95"
                  enterTo="opacity-100 scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 scale-100"
                  leaveTo="opacity-0 scale-95"
                >
                  <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                    <Dialog.Title
                      as="h3"
                      className="text-lg font-medium leading-6 text-gray-900"
                    >
                      {t("PROFILE.confirm")}
                    </Dialog.Title>
                    <div className="mt-2">
                      <p className="text-sm text-gray-500">
                        {t("PROFILE.toLogout")}
                      </p>
                    </div>

                    <div className="mt-4 flex gap-2">
                      <button
                        type="button"
                        className="inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                        onClick={() => logout()}
                      >
                        {t("PROFILE.yes")}
                      </button>
                      <button
                        type="button"
                        className="inline-flex justify-center rounded-md border border-transparent bg-red-100 px-4 py-2 text-sm font-medium text-red-900 hover:bg-red-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:ring-offset-2"
                        onClick={() => closeActionLogout()}
                      >
                        {t("PROFILE.no")}
                      </button>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition>
      </div>
    </>
  );
};

export default ProfileWeb;
